const getPolls = () => ({
  results: [
    {
      id: 54,
      campaignId: 421,
      showStartOn: null,
      showEndOn: null,
      validStartOn: null,
      validEndOn: null,
      statusId: 1,
      status: 'ACTIVE',
      addedOn: '2022-07-22T17:38:57.000Z',
      updatedOn: '2022-07-22T17:43:01.000Z',
      description: {
        title: 'Change the background',
        language: 'ENGLISH',
      },
      options: [
        {
          id: 178,
          pollId: 54,
          iconId: 58,
          icon: 'fa-var-arrow-alt-circle-right',
          votes: '1',
          collected: '25.00',
          addedOn: '2022-07-22T17:40:27.000Z',
          description: {
            description: 'Super Metroid',
            language: 'ENGLISH',
          },
        },
        {
          id: 179,
          pollId: 54,
          iconId: 58,
          icon: 'fa-var-arrow-alt-circle-right',
          votes: '1',
          collected: '502.00',
          addedOn: '2022-07-22T17:40:34.000Z',
          description: {
            description: 'A Link to the Past',
            language: 'ENGLISH',
          },
        },
        {
          id: 180,
          pollId: 54,
          iconId: 58,
          icon: 'fa-var-arrow-alt-circle-right',
          votes: '1',
          collected: '300.00',
          addedOn: '2022-07-22T17:40:42.000Z',
          description: {
            description: 'Axiom Verge',
            language: 'ENGLISH',
          },
        },
        {
          id: 181,
          pollId: 54,
          iconId: 58,
          icon: 'fa-var-arrow-alt-circle-right',
          votes: '1',
          collected: '501.00',
          addedOn: '2022-07-22T17:40:50.000Z',
          description: {
            description: 'Mega Man Maker',
            language: 'ENGLISH',
          },
        },
        {
          id: 182,
          pollId: 54,
          iconId: 58,
          icon: 'fa-var-arrow-alt-circle-right',
          votes: '1',
          collected: '420.69',
          addedOn: '2022-07-22T17:40:57.000Z',
          description: {
            description: 'Gotta Go Slow',
            language: 'ENGLISH',
          },
        },
        {
          id: 183,
          pollId: 54,
          iconId: 58,
          icon: 'fa-var-arrow-alt-circle-right',
          votes: '1',
          collected: '500.00',
          addedOn: '2022-07-22T17:41:04.000Z',
          description: {
            description: 'Chrono Trigger',
            language: 'ENGLISH',
          },
        },
        {
          id: 190,
          pollId: 54,
          iconId: 58,
          icon: 'fa-var-arrow-alt-circle-right',
          votes: '0',
          collected: '0.00',
          addedOn: '2022-07-28T16:49:47.000Z',
          description: {
            description: 'Mario RPG',
            language: 'ENGLISH',
          },
        },
        {
          id: 191,
          pollId: 54,
          iconId: 58,
          icon: 'fa-var-arrow-alt-circle-right',
          votes: '1',
          collected: '3000.00',
          addedOn: '2022-07-28T16:49:59.000Z',
          description: {
            description: 'Kirby',
            language: 'ENGLISH',
          },
        },
      ],
      optionsCount: {
        options: 8,
        votes: 7,
      },
    },
    {
      id: 55,
      campaignId: 421,
      showStartOn: null,
      showEndOn: null,
      validStartOn: null,
      validEndOn: null,
      statusId: 1,
      status: 'ACTIVE',
      addedOn: '2022-07-22T17:42:04.000Z',
      updatedOn: '2022-07-22T17:42:51.000Z',
      description: {
        title: 'Change the borders',
        language: 'ENGLISH',
      },
      options: [
        {
          id: 184,
          pollId: 55,
          iconId: 58,
          icon: 'fa-var-arrow-alt-circle-right',
          votes: '2',
          collected: '1088.00',
          addedOn: '2022-07-22T17:42:13.000Z',
          description: {
            description: 'Super Metroid',
            language: 'ENGLISH',
          },
        },
        {
          id: 185,
          pollId: 55,
          iconId: 58,
          icon: 'fa-var-arrow-alt-circle-right',
          votes: '2',
          collected: '464.69',
          addedOn: '2022-07-22T17:42:19.000Z',
          description: {
            description: 'A Link to the Past',
            language: 'ENGLISH',
          },
        },
        {
          id: 186,
          pollId: 55,
          iconId: 58,
          icon: 'fa-var-arrow-alt-circle-right',
          votes: '1',
          collected: '300.00',
          addedOn: '2022-07-22T17:42:25.000Z',
          description: {
            description: 'Axiom Verge',
            language: 'ENGLISH',
          },
        },
        {
          id: 187,
          pollId: 55,
          iconId: 58,
          icon: 'fa-var-arrow-alt-circle-right',
          votes: '1',
          collected: '999.00',
          addedOn: '2022-07-22T17:42:31.000Z',
          description: {
            description: 'Mega Man Maker',
            language: 'ENGLISH',
          },
        },
        {
          id: 188,
          pollId: 55,
          iconId: 58,
          icon: 'fa-var-arrow-alt-circle-right',
          votes: '2',
          collected: '540.69',
          addedOn: '2022-07-22T17:42:39.000Z',
          description: {
            description: 'Gotta Go Slow',
            language: 'ENGLISH',
          },
        },
        {
          id: 189,
          pollId: 55,
          iconId: 58,
          icon: 'fa-var-arrow-alt-circle-right',
          votes: '1',
          collected: '80.00',
          addedOn: '2022-07-22T17:42:48.000Z',
          description: {
            description: 'Chrono Trigger',
            language: 'ENGLISH',
          },
        },
        {
          id: 192,
          pollId: 55,
          iconId: 58,
          icon: 'fa-var-arrow-alt-circle-right',
          votes: '0',
          collected: '0.00',
          addedOn: '2022-07-28T16:50:34.000Z',
          description: {
            description: 'Mario RPG',
            language: 'ENGLISH',
          },
        },
        {
          id: 193,
          pollId: 55,
          iconId: 58,
          icon: 'fa-var-arrow-alt-circle-right',
          votes: '0',
          collected: '0.00',
          addedOn: '2022-07-28T16:51:40.000Z',
          description: {
            description: 'Kirby',
            language: 'ENGLISH',
          },
        },
      ],
      optionsCount: {
        options: 8,
        votes: 9,
      },
    },
  ],
  pagination: {
    pageNumber: 1,
    pageResults: 20,
    totalResults: 2,
  },
  orderBy: null,
  filterBy: null,
  callSuccess: true,
  code: 200,
});

const backgroundId = 54;
const frameId = 55;

export const getHighestValue = pollData => {
  if (!pollData) return null;
  const sortedOptions = pollData.options.sort(
    (a, b) => parseFloat(b.collected) - parseFloat(a.collected),
  );
  return sortedOptions[0];
};

export const getBackgroundPolls = () => {
  const poll = getPolls().results.find(poll => poll.id === backgroundId);
  const results = getHighestValue(poll);
  return results;
};

export const getFramePolls = () => {
  const poll = getPolls().results.find(poll => poll.id === frameId);
  const results = getHighestValue(poll);
  return results;
};

// TODO: Replacing URL is a temporary last minute NR7 patch, going around the proxy
export const WEBSITE_API_URL = process.env.NEXT_PUBLIC_DOMAIN.replace(
  'host.docker.internal',
  'localhost',
);
